import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import CatalogsEthContent from "modules/CatalogsEth";
import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const CatalogsEthPage: React.FC = () => {
  setTitle("Ethereum");
  return (
    <Auth>
      <Layout>
        <CatalogsEthContent />
      </Layout>
    </Auth>
  );
};

export default CatalogsEthPage;
